import type { FC } from "react";
import type { ContentFileDto } from "shared";
import { Icon } from "../../common/Icon";
import { PreviewAvatar } from "../shared/PreviewAvatar";
import { PreviewMedia } from "../shared/PreviewMedia";
import "./FacebookPreview.css";

interface FacebookPreviewProps {
	companyName: string;
	content: string;
	files: ContentFileDto[];
}

export const FacebookPreview: FC<FacebookPreviewProps> = ({
	companyName,
	content,
	files,
}) => {
	return (
		<div className="fb-preview">
			<div className="fb-preview__header">
				<PreviewAvatar name={companyName} subtitle="2h · " size="md" />
				<Icon name="public" size={14} className="fb-preview__globe" />
			</div>

			<div className="fb-preview__content">
				<p className="fb-preview__text">{content}</p>
			</div>

			{files.length > 0 && <PreviewMedia files={files} aspectRatio="16:9" />}

			<div className="fb-preview__stats">
				<span className="fb-preview__reactions">
					<span className="fb-preview__reaction-icons">
						<span className="fb-preview__reaction fb-preview__reaction--like">
							👍
						</span>
						<span className="fb-preview__reaction fb-preview__reaction--love">
							❤️
						</span>
					</span>
					<span>42</span>
				</span>
				<span className="fb-preview__comments">5 comments</span>
			</div>

			<div className="fb-preview__actions">
				<button type="button" className="fb-preview__action">
					<Icon name="thumb_up" size={20} />
					<span>Like</span>
				</button>
				<button type="button" className="fb-preview__action">
					<Icon name="chat_bubble" size={20} />
					<span>Comment</span>
				</button>
				<button type="button" className="fb-preview__action">
					<Icon name="share" size={20} />
					<span>Share</span>
				</button>
			</div>
		</div>
	);
};
